import * as React from 'react';

import './tab.sass';

export function Tab(props) {
  return (
    <button type="button" className="element--tab h-40 fw-700 fs-14" {...props} />
  );
}
